import { render } from "./RightIcon.vue?vue&type=template&id=88e21a60"
import script from "./RightIcon.vue?vue&type=script&lang=js"
export * from "./RightIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__